import {makeStyles, Typography} from '@material-ui/core'
import {IndustryV2} from 'api/authApi'
import {useBoldInputStyle} from 'components/common/useBoldInputStyle'
import SelectBoldIndustryWrapper from 'components/Dialog/BoldSelect/SelectBoldIndustry'
import * as React from 'react'
import {useFormContext} from 'react-hook-form'
import {useTranslation} from 'react-i18next'
import RegisterStyle from '../Style'

export default function SelectedIndustry() {
  const createOrgInfo = useFormContext()
  const useStyles = makeStyles(RegisterStyle)
  const classes = useStyles()
  const inputClasses = useBoldInputStyle()
  const {t} = useTranslation()

  const [industry, setIndustry] = React.useState<IndustryV2>({
    id: 0,
    title: '',
  })
  const [detailIndustry, setDetailIndustry] = React.useState<IndustryV2>({
    id: 0,
    title: '',
  })

  const handleDivisionChanged = (industry: Industry) => {
    if (industry.id) {
      setIndustry({id: industry.id, title: industry.title})
    }
  }

  const handlePositionChanged = (industry: Industry) => {
    if (industry.id) {
      setDetailIndustry({id: industry.id, title: industry.title})
    }
    console.log(detailIndustry)
  }

  const {
    formState: {errors},
  } = useFormContext()

  const isNotSelectedIndustry = () => {
    if (errors.industry || errors.industryDetail) {
      return true
    }
    return false
  }

  return (
    <>
      <div className={classes.industryContainer}>
        <div className={classes.industryWrap}>
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              alignContent: 'center',
            }}
          >
            <p className={inputClasses.inputLabel}>{t('IIndustry')}</p>
            <p className={inputClasses.require}>*</p>
          </div>
          <SelectBoldIndustryWrapper
            parent={0}
            depth={1}
            selectedValue={t('ISelectRequired')}
            onChangeData={handleDivisionChanged}
            {...createOrgInfo.register('industry', {
              required: `${t('IRequired')}`,
            })}
          />
        </div>
        <Typography className={classes.industryPadding} />
        <div className={classes.industryWrap}>
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              alignContent: 'center',
            }}
          >
            <p className={inputClasses.inputLabel}>{t('IIndustryDetail')}</p>
            <p className={inputClasses.require}>*</p>
          </div>

          <SelectBoldIndustryWrapper
            parent={industry.id ?? 0}
            depth={2}
            selectedValue={t('ISelectRequired')}
            onChangeData={handlePositionChanged}
            {...createOrgInfo.register('industryDetail', {
              required: `${t('IRequired')}`,
            })}
          />
        </div>
      </div>
      {isNotSelectedIndustry() && (
        <div className={classes.errorText}>{t('IRequired')}</div>
      )}
    </>
  )
}
